module.exports = __webpack_public_path__ + "4106b07d11d42e4aeadbf181f834c909.png";